import { Fragment } from 'react'

import { Breakpoint, useCheckBreakpoint } from '~/utils'

import HorisontalArticleGroup from './HorisontalArticleGroup/HorisontalArticleGroup'
import VerticalArticleGroup from './VerticalArticleGroup/VerticalArticleGroup'
import VerticalArticleItem from './VerticalArticleGroup/VerticalArticleItem'
import useArticlesList from './ArticlesList.hook'
import { ArticleListItem } from './ArticlesList.types'

export default function ArticlesList({
  articles,
  className = '',
}: {
  articles: ArticleListItem[]
  className?: string
}): React.ReactElement {
  const isSmallScreen = useCheckBreakpoint({ lt: Breakpoint.LG })
  const { latest, rest, restChunkedWithIteratorKey } = useArticlesList(articles)

  if (isSmallScreen) {
    return (
      <div className={`${className}`}>
        <VerticalArticleGroup articles={[latest, ...rest]} />
      </div>
    )
  }

  return (
    <div className={`${className}`}>
      <VerticalArticleItem
        {...latest}
        className="block mb-12 p-6 border border-purple-medium rounded shadow-large"
        slug={latest.slug.current}
      />

      <Fragment>
        {restChunkedWithIteratorKey.map((elem, index) =>
          index % 2 === 0 ? (
            <HorisontalArticleGroup
              className="mb-12 grid grid-cols-3 gap-8"
              {...elem}
              key={`restChunkedWithIteratorKey-${index}`}
            />
          ) : (
            <VerticalArticleGroup className="mb-16" {...elem} key={`restChunkedWithIteratorKey-${index}`} />
          ),
        )}
      </Fragment>
    </div>
  )
}
